/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrCustomBadRequest1Typename = "PhrCustomBadRequest1" as const;

/**
 *
 * @export
 * @interface PhrCustomBadRequest1
 */
export interface PhrCustomBadRequest1 {
  /**
   *
   * @type {number}
   * @memberof PhrCustomBadRequest1
   */
  code: number;
  /**
   *
   * @type {string}
   * @memberof PhrCustomBadRequest1
   */
  detailCode?: PhrCustomBadRequest1DetailCodeEnum;
  /**
   *
   * @type {string}
   * @memberof PhrCustomBadRequest1
   */
  message: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrCustomBadRequest1
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PhrCustomBadRequest1DetailCodeEnum {
  PatientPhrE001 = "Patient-PHR-E001",
}

export function PhrCustomBadRequest1FromJSON(json: any): PhrCustomBadRequest1 {
  return PhrCustomBadRequest1FromJSONTyped(json, false);
}

export function PhrCustomBadRequest1FromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrCustomBadRequest1 {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrCustomBadRequest1Typename,

    code: json["code"],
    detailCode: !exists(json, "detail_code") ? undefined : json["detail_code"],
    message: json["message"],
  };
}

export function PhrCustomBadRequest1ToJSON(object?: PhrCustomBadRequest1 | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    code: value.code,
    detail_code: value.detailCode,
    message: value.message,
  };
}
